import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { User } from '@ml/core/types/classes';
import { SidenavOption } from '@ml/core/types/interfaces/sidenav-option.interface';
import { Router } from '@angular/router';

@Component({
  selector: 'ml-app-bar',
  template: `
    <mat-toolbar class="toolbar">
      <mat-toolbar-row style="height: 48px">
        <span fxShow.md="true" fxHide>{{ title | translate | titlecase }}</span>
        <span class="fill"></span>
        <div class="username">{{ user.name }}</div>
        <button
          *ngIf="connection"
          mat-icon-button
          (click)="openNotifications.emit()"
        >
          <mat-icon svgIcon="notifications" class="toolbar__notifications_icon">
            <span
              [hidden]="!unreadNotifications"
              class="toolbar__notifications_icon--circle"
            ></span>
          </mat-icon>
        </button>
        <button mat-icon-button [matMenuTriggerFor]="accountMenu">
          <mat-icon svgIcon="account_circle"> </mat-icon>
        </button>
        <flag-icon
          style="padding-right: 8px"
          *ngIf="connection"
          (click)="onChangeLanguage('en')"
          class="flag"
          country="gb"
        ></flag-icon>
        <flag-icon
          *ngIf="connection"
          (click)="onChangeLanguage('de-LU')"
          class="flag"
          country="de"
        ></flag-icon>

        <mat-menu #accountMenu="matMenu">
          <button
            fxLayout="row"
            fxLayoutAlign="start center"
            mat-menu-item
            (click)="onLogOut()"
          >
            <mat-icon matPrefix svgIcon="exit_to_app"></mat-icon>
            {{ 'logout' | translate }}
          </button>

          <button
            fxShow
            fxHide.lg
            fxLayout="row"
            fxLayoutAlign="start center"
            mat-menu-item
            *ngFor="let option of sidenavOptions"
            (click)="onSelectSidenavOption(option)"
          >
            <mat-icon matPrefix [svgIcon]="option.icon"></mat-icon>
            {{ option.name | translate | titlecase }}
          </button>
        </mat-menu>
      </mat-toolbar-row>
    </mat-toolbar>
  `,
  styleUrls: ['./app-bar.component.scss']
})
export class AppBarComponent implements OnInit {
  @Input() title: string;
  @Input() user: User;
  @Input() unreadNotifications: boolean;
  @Input() connection: boolean;
  @Input() sidenavOptions: SidenavOption[];
  @Output() logout = new EventEmitter();
  @Output() openNotifications = new EventEmitter();

  constructor(private router: Router, public translate: TranslateService) {}

  ngOnInit() {}

  onLogOut() {
    this.logout.emit();
  }

  onSelectSidenavOption(option: SidenavOption) {
    this.router.navigate([option.routerLink]);
  }

  onChangeLanguage(language: string) {
    localStorage.setItem('ml_language', language);
    this.translate.use(language);
    window.location.reload();
  }
}
